<template>
  <main class="page-container flex flex-column align-items-center justify-content-center min-h-screen px-4 text-center">
    <h1 class="m-0 text-xl font-semibold text-900">{{ $t('auth.roleMismatchTitle') }}</h1>
    <p class="m-0 mt-3 text-600 line-height-3">
      {{ $t('auth.roleMismatchMessage', { expected: expectedLabel, actual: actualLabel }) }}
    </p>
    <PButton
      class="mt-4 w-full"
      :label="$t('auth.roleMismatchLogout')"
      severity="secondary"
      @click="handleLogout"
    />
  </main>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '@/stores/auth'

const { t } = useI18n()
const authStore = useAuthStore()

const expectedLabel = computed(() => t(`roles.${authStore.expectedAppRole}`))
const actualLabel = computed(() =>
  authStore.user?.role ? t(`roles.${authStore.user.role}`) : '—',
)

async function handleLogout() {
  await authStore.logout()
}
</script>
